import React from 'react';
import styled from 'styled-components';
import * as Ant from 'antd';
import {Helmet} from 'react-helmet';
import BeltCarousel from './BeltCarousel';
import {Facebook} from '@styled-icons/fa-brands/Facebook';
import {Instagram} from '@styled-icons/fa-brands/Instagram';
import {Line} from '@styled-icons/fa-brands/Line';
import {Youtube} from '@styled-icons/fa-brands/Youtube';
import {Twitter} from '@styled-icons/fa-brands/Twitter';
import {mapLineBreak} from '../../Utils/TextUtil';
import ProductItem from './ProductItem';
import constants from '../../constants';

export default function CreatorDetail(props) {
  const {pageContext} = props;
  const {prebuiltCreator: creator} = pageContext;

  return (
    <>
      <Helmet>
        <title>{constants.SITE_INFO.title}</title>
        <meta property="og:site_name" content={constants.SITE_INFO.title} />
        <meta property="og:title" content={creator.og_title || creator.name} />
        <meta
          property="og:image"
          content={creator.og_image?.[0] || creator.image}
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="314" />
        <meta
          property="og:description"
          content={creator.og_description || creator.description}
        />

        <meta name="title" content={constants.SITE_INFO.title} />
        <meta name="description" content={constants.SITE_INFO.description} />
        <meta name="image" content={constants.SITE_INFO.icon} />
      </Helmet>

      <Wrapper id="rev-CreatorDetailPage">
        <div className="banner">
          <img
            src={creator.bg_image || '/images/creator-default-banner.webp'}
            alt="creator-banner"
          />
        </div>
        <div className="content">
          <div className="creator-profile">
            <div className="card">
              <img src={creator.image} alt="creator" />
              <h2>{creator.name}</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: mapLineBreak(creator.description || ''),
                }}
              />
              <Ant.Button
                type="primary"
                ghost
                size="large"
                style={{width: '100%'}}>
                <a
                  href={`mailto:${creator.email}`}
                  target="_blank"
                  rel="noreferrer">
                  訊息
                </a>
              </Ant.Button>
              <div className="social-items">
                {creator.social_fb && (
                  <a href={creator.social_fb} target="_blank" rel="noreferrer">
                    <Facebook size={32} />
                  </a>
                )}

                {creator.social_ig && (
                  <a href={creator.social_ig} target="_blank" rel="noreferrer">
                    <Instagram size={32} />
                  </a>
                )}

                {creator.social_line && (
                  <a
                    href={creator.social_line}
                    target="_blank"
                    rel="noreferrer">
                    <Line size={32} />
                  </a>
                )}

                {creator.social_youtube && (
                  <a
                    href={creator.social_youtube}
                    target="_blank"
                    rel="noreferrer">
                    <Youtube size={32} />
                  </a>
                )}

                {creator.social_twitter && (
                  <a
                    href={creator.social_twitter}
                    target="_blank"
                    rel="noreferrer">
                    <Twitter size={32} />
                  </a>
                )}
              </div>
            </div>

            <div className="gutter" />

            <div className="tabs">
              <Ant.Tabs
                tabBarStyle={{
                  borderBottom: '1px solid #aeb6b8',
                  color: '#7d7d7d',
                }}>
                <Ant.Tabs.TabPane
                  tab="創作者故事"
                  key="item-1"
                  style={{
                    paddingTop: 40,
                    paddingBottom: 40,
                  }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: mapLineBreak(creator.story || ''),
                    }}
                  />
                </Ant.Tabs.TabPane>
                <Ant.Tabs.TabPane
                  tab="品牌公告"
                  key="item-2"
                  style={{
                    paddingTop: 40,
                    paddingBottom: 40,
                  }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: mapLineBreak(creator.bulletin || ''),
                    }}
                  />

                  <br />
                  <p>
                    ★ 本站商品皆為「{creator.name}」設計並授權好好選 HoHoKing
                    製作及營運。
                  </p>
                </Ant.Tabs.TabPane>
                <Ant.Tabs.TabPane
                  tab="退換貨政策"
                  key="item-3"
                  style={{
                    paddingTop: 40,
                    paddingBottom: 40,
                  }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: mapLineBreak(creator.return || ''),
                    }}
                  />
                </Ant.Tabs.TabPane>
              </Ant.Tabs>
            </div>
          </div>

          <div className="creator-page-divider" />

          <div className="belt-carousel">
            <div className="title-container">
              <h2>創作者動態</h2>
              <h3 style={{marginBottom: 30}}>Creator News</h3>
            </div>

            <BeltCarousel items={creator.dynamics || []} />
          </div>
          <div className="products">
            <div className="title-container">
              <h2>創作者商品</h2>
              <h3>Creations</h3>
            </div>

            <div className="content-container">
              {creator.products.map((product, index) => (
                <ProductItem key={index} product={product} />
              ))}

              {[0, 1, 2, 3].map((_, index) => (
                <ProductItem key={`fake-${index}`} />
              ))}
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topCustomNavBarHeight);
  min-height: calc(100vh - 300px);

  background-color: #f0f0f0;

  & > .banner {
    height: 330px;
    & > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  & > .content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    margin-top: -220px;

    & .title-container {
      margin-bottom: 30px;
      & > h2,
      h3 {
        color: var(--primaryColor);
      }
    }

    & > .creator-profile {
      display: flex;
      align-items: flex-start;

      & > .card {
        width: 320px;
        height: 500px;
        border-radius: 10px;
        padding: 30px;
        background-color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);

        & > img {
          width: 120px;
          height: 120px;
          border-radius: 60px;
          overflow: hidden;
          object-fit: cover;
        }

        & > h2 {
          text-align: center;
          font-size: 1.6rem;
        }

        & > h2 ~ div {
          text-align: center;
          color: #888;
        }

        & > .social-items {
          align-self: stretch;
          display: flex;
          justify-content: space-around;
        }

        &:hover {
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
        }
      }

      & > .gutter {
        height: 60px;
        width: 60px;
      }

      & > .tabs {
        flex: 1;
        margin-top: 220px;
      }

      @media (max-width: 768px) {
        display: block;
        position: relative;

        & > .card {
          margin: 0 auto;
        }

        & > .tabs {
          margin-top: 0px;
        }
      }
    }

    & > .creator-page-divider {
      margin-top: 55px;
      border-top: 1px solid #aeb6b8;
    }

    & > .belt-carousel {
      margin-bottom: 55px;
      padding-top: 52px;
    }

    & > .products {
      & > .content-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        @media screen and (max-width: 700px) {
          justify-content: space-around;
        }
      }
    }
  }
`;
